import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, FieldArray, formValueSelector} from 'redux-form';
import {Button, Card, Grid, Dropdown, Form, Icon, Tab} from 'semantic-ui-react';
import {buildUniqueCodeFromAgencyObj, getAgencyFromUniqueCodeStr} from './common/utils';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {panes, PANES_INDICES} from '../../../common/dictionaries/scanning';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {warehouses} from '../../../common/dictionaries/parameters';
import {TOYOTA_RUC} from '../../../common/constants/dealer';
import {paths} from '../../../common/dictionaries/urls';
import {SCANNING_FORM} from '../../../common/forms';
import {Actions} from '../../../common/actions';
import ProgressBar from '../../../common/components/progressBar';
import ScanningTable from './lists/scanningTable';
import PendingItemsTable from './lists/pendingItemsTable';
import ReviewedItemsTable from './lists/reviewedItemsTable';
import './scanning.scss';

class Scanning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'currentAgency': '',
      'selectedAgency': '',
      'currentItem': 0,
    };

    this.onAgencyDropdownChange = this.onAgencyDropdownChange.bind(this);
    this.onRefreshClick = this.onRefreshClick.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
    this.onGenerateInvoiceClick = this.onGenerateInvoiceClick.bind(this);
    this.setCurrentItemIndex = this.setCurrentItemIndex.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingScanning,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearScanningInfo();
    this.props.clearScanningItems();
    this.props.fetchAgenciesList({'warehouse': warehouses.main});
  }

  componentDidUpdate(prevProps) {
    const {processingInvoice} = this.props;

    if (processingInvoice && !prevProps.processingInvoice) {
      this.setState({
        'currentAgency': '',
        'selectedAgency': '',
        'activeTabIndex': 0,
      });
    }
  }

  getAgencyDropdownOptions() {
    const {agencies} = this.props;

    return agencies.map((agency) => {
      return {
        'text': `${agency.dealerName} - ${agency.name}`,
        'value': buildUniqueCodeFromAgencyObj(agency),
      };
    });
  }

  onAgencyDropdownChange(event, {value}) {
    this.setState({'selectedAgency': value, 'activeTabIndex': 0}, () => this.onAgencyUpdate());
  }

  onAgencyUpdate() {
    const {agencies} = this.props;
    const {currentAgency, selectedAgency, currentItem} = this.state;

    if (currentAgency === selectedAgency) {
      return;
    }

    this.setState({'currentAgency': selectedAgency});
    this.props.clearScanningInfo();
    this.props.clearScanningItems();
    this.props.fetchAgency(
      getAgencyFromUniqueCodeStr(agencies, selectedAgency)
    );

    const orderSequenceCodeInput = document.getElementsByName(
      `items[${currentItem}].orderSequenceCode`
    );
    if (orderSequenceCodeInput.length) {
      orderSequenceCodeInput[0].focus();
    }
  }

  onRefreshClick() {
    this.setState({
      'currentAgency': '',
      'selectedAgency': '',
      'currentItem': 0,
    });

    this.props.clearScanningInfo();
    this.props.clearScanningItems();
    this.props.fetchAgenciesList({'warehouse': warehouses.main});
  }

  onTabChange(event, data) {
    this.setState({'activeTabIndex': data.activeIndex});
  }

  onGenerateInvoiceClick() {
    const {agencyData} = this.props;

    if (agencyData.checkedLines < agencyData.totalLines) {
      this.props.navigateTo(paths.ScanningWarehouseDenied);
    } else if (agencyData.dealerIdentification === TOYOTA_RUC.toString()) {
      this.props.processStockTransfer({
        'dealer': agencyData.dealerIdentification,
        'agency': agencyData.code,
        'origin': 'CPD',
        'destination': 'LOG',
      });
    } else {
      this.props.createPartSaleInvoice({
        'dealer': agencyData.dealerIdentification,
        'agency': agencyData.code,
      });
    }
  }

  setCurrentItemIndex(index) {
    this.setState({'currentItem': index});
  }

  renderProgressBar() {
    if (!this.state.currentAgency) {
      return null;
    }

    const {loadingAgencyData, agencyData} = this.props;
    return (
      <ProgressBar
        label='Líneas'
        loading={loadingAgencyData}
        partialQuantity={agencyData.checkedLines}
        totalQuantity={agencyData.totalLines}
      />
    );
  }

  renderScanningPaneContent() {
    return (
      <Form className='primary-content' autoComplete='off'>
        <FieldArray
          name='items'
          component={ScanningTable}
          currentItem={this.state.currentItem}
          setCurrentItemIndex={this.setCurrentItemIndex}
        />
      </Form>
    );
  }

  renderPanesContent() {
    const {activeTabIndex} = this.state;
    const tabs = {
      [PANES_INDICES.SCANNING_LIST]: this.renderScanningPaneContent(),
      [PANES_INDICES.PENDING_LIST]: <PendingItemsTable />,
      [PANES_INDICES.REVIEWED_LIST]: <ReviewedItemsTable />,
    };
    return tabs[activeTabIndex] || null;
  }

  render() {
    const {loadingAgencies, loadingAgencyData, processingInvoice} =
      this.props;
    const {selectedAgency, currentAgency} = this.state;

    return (
      <div className='scanning-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Picking - Escaneo</h2>
              <div className='title-bar-actions'>
                {this.renderProgressBar()}
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Agencia</h4>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Dropdown
                      value={selectedAgency}
                      options={this.getAgencyDropdownOptions()}
                      selection
                      search
                      loading={loadingAgencies}
                      disabled={loadingAgencies}
                      placeholder='Seleccione una agencia'
                      noResultsMessage='Agencia no encontrada'
                      onChange={this.onAgencyDropdownChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Button
                      primary
                      type='button'
                      loading={loadingAgencies}
                      disabled={loadingAgencies}
                      className='toyota-primary refresh'
                      onClick={this.onRefreshClick}
                    >
                      <Icon name='refresh' size='large' />
                    </Button>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Tab
                      menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
                      panes={panes}
                      activeIndex={this.state.activeTabIndex}
                      onTabChange={this.onTabChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={3} textAlign='right'>
                    <Button
                      primary
                      type='button'
                      className='toyota-primary'
                      disabled={
                        !selectedAgency ||
                        loadingAgencyData ||
                        processingInvoice
                      }
                      loading={processingInvoice}
                      onClick={this.onGenerateInvoiceClick}
                    >
                      PROCESAR
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        {currentAgency !== '' && (
          <Card raised fluid>
            {this.renderPanesContent()}
          </Card>
        )}
      </div>
    );
  }
}

export {Scanning};

const form = reduxForm({
  'form': SCANNING_FORM.name,
})(Scanning);

const mapStateToProps = (state) => {
  const formValues = formValueSelector(SCANNING_FORM.name);
  const items = formValues(state, 'items');

  return {
    items,
    'processingInvoice': state.scanning.creatingInvoice,
    'loadingAgencies': state.scanning.loadingAgenciesList,
    'agencies': state.scanning.agenciesList,
    'loadingAgencyData': state.scanning.loadingAgencyData,
    'agencyData': state.scanning.agencyData,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  clearScanningInfo,
  clearScanningItems,
  fetchAgenciesList,
  fetchAgency,
  createPartSaleInvoice,
  processStockTransfer,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  clearScanningInfo,
  clearScanningItems,
  fetchAgenciesList,
  fetchAgency,
  createPartSaleInvoice,
  processStockTransfer,
  navigateTo,
})(form);
